<template>
  <div>
    <projects-management></projects-management>
  </div>
</template>

<script>
import ProjectsManagement from "./ProjectsManagement";

export default {
  name: "BPMComposer",
  components: {
    "projects-management": ProjectsManagement
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {},
  watch: {}
};
</script>
